<template>
  <div class="upload">
    <slot name="required"></slot>
    <slot name="errors" :limit="limit" :size="size" :typeError="typeError">
      <div class="upload__errors" v-if="limit || size || typeError">
        <span class="upload__error" v-if="limit">{{ _("Exceeded the maximum number of files to upload") }}</span>
        <span class="upload__error" v-if="size">{{ _("Exceeded the maximum file weight for download") }}</span>
        <span class="upload__error" v-if="typeError">{{ _("Unsupported file format") }}</span>
      </div>
    </slot>
    <div class="upload__wrapper" :class="{'disabled': files.length == maxFiles}">
      <label class="label" :for="id">
        <slot name="button">
          <div class="upload__button">
            <span>{{ buttonText }}</span>
          </div>
        </slot>
        <input class="upload__input" v-if="multipleFiles == true" type="file" :id="id" multiple="multiple" :accept="acceptedFilesReplaced" @change="onFileChange" />
        <input class="upload__input" v-if="multipleFiles == false" type="file" :id="id" :accept="acceptedFilesReplaced" @change="onFileChange" />
      </label>
    </div>
    <div class="upload__message">
      <div class="upload__title">{{ _("Requirements for downloaded files ") }}</div>
      <slot name="info" :maxFiles="maxFiles" :maxSize="maxSize" :acceptedFiles="acceptedFiles">
        <div class="upload__info">
          <span>({{ _("Maximum number of files - ") }} {{ maxFiles }}, </span>
          <span>{{ _("maximum file size - ") }} {{ maxSize }} {{ _("MB") }}, </span>
          <span>{{ _("allowed formats - ") }} {{ acceptedFiles }})</span>
        </div>
      </slot>
    </div>
    <div class="upload-list" v-if="files.length > 0">
      <div class="upload-list__item" v-for="(file, index) in files" :class="{'upload-list__item--doc': !checkOnImageFile(file)}">
        <div v-if="checkOnImageFile(file)">
          <div class="upload-list__file-wrapper">
            <img class="upload-list__file" :src="file" alt=""/>
          </div>
          <slot name="filesName" :filesName="filesName" :index="index">
            <p>{{ filesName[index] }}</p>
          </slot>
        </div>
        <div class="upload-list__tag" v-else="v-else">{{ filesName[index] }}</div>
        <div class="upload-list__remove" @click="removeFile(index)" :class="{'upload-list__remove--doc': !checkOnImageFile(file)}">
          <slot name="remove">
            <i>x</i>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: 'upload'
    },
    maxSize: {
      type: Number,
      default: 5
    },
    maxFiles: {
      type: Number,
      default: 5
    },
    acceptedFiles: {
      type: String,
      default: '.jpg, .jpeg, .png, .gif'
    },
    multipleFiles: {
      type: Boolean,
      default: true
    },
    buttonText: {
      type: String,
      default: 'Upload file'
    },
    defaultFiles: {
      type: Array,
      default: () => []
    },
    removeFilesIsActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      acceptedFilesReplaced: '',
      bytes: 1000,
      files: [],
      filesName: [],
      filesSize: [],
      headers: '',
      limit: false,
      megabyte: 1048576,
      size: false,
      one: 1,
      typeError: false,
      zero: 0
    }
  },
  watch: {
    defaultFiles: {
      handler() {
        this.setDefaultFiles()
      }
    },
    removeFilesIsActive: {
      handler() {
        this.removeFiles()
      }
    }
  },
  mounted() {
    this.acceptedFilesReplaced = this.acceptedFiles.replace(/ /g, '')
    this.setDefaultFiles()
  },
  methods: {
    removeFiles() {
      if (this.removeFilesIsActive) {
        this.files = []
        this.filesSize = []
        this.filesName = []
      }
    },
    setDefaultFiles() {
      if (this.zero < this.defaultFiles.length) {
        this.defaultFiles.forEach(el => {
          this.files.push(el.url)
          this.filesSize.push(el.size)
          this.filesName.push(el.name)
        })
      }
    },
    checkOnImageFile(file) {
      let lowercaseUrl = file.toLowerCase()
      return lowercaseUrl.includes('data:image/jpeg;base64') ||
        lowercaseUrl.includes('data:image/jpg;base64') ||
        lowercaseUrl.includes('data:image/png;base64') ||
        lowercaseUrl.includes('data:image/gif;base64') ||
        lowercaseUrl.includes('.jpeg') ||
        lowercaseUrl.includes('.jpg') ||
        lowercaseUrl.includes('.png') ||
        lowercaseUrl.includes('.gif') ||
        lowercaseUrl.includes('.jpe')
    },
    onFileChange(e) {
      this.size = false
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.createFile(files)
    },
    emitFiles(index) {
      this.$emit('files-change', {
        files: this.files,
        filesName: this.filesName,
        filesSize: this.filesSize,
        deletedFileIndex: index
      })
    },
    createFile(files) {
      let fileFormat = files[0].name.split('.')
      fileFormat = `.${fileFormat[fileFormat.length - +'1']}`
      let acceptedFormats
      let vm = this
      acceptedFormats = this.acceptedFilesReplaced.split(',')
      if (this.zero <= acceptedFormats.indexOf(fileFormat.toLowerCase())) {
        this.typeError = false
        if (this.files.length + files.length <= parseInt(this.maxFiles)) {
          this.limit = false
          Object.keys(files).forEach(el => {
            if (files[el].size <= parseInt(this.maxSize) * this.megabyte) {
              let reader = new FileReader()
              let addInfoFile = el => {
                this.filesName.push(files[el].name)
                this.filesSize.push(
                  (files[el].size / this.bytes).toFixed(this.zero)
                )
              }
              reader.onload = e => {
                vm.files.push(e.target.result)
                addInfoFile(el)
              }
              reader.readAsDataURL(files[el])
              this.emitFiles()
            } else {
              this.size = true
            }
          })
        } else {
          this.limit = true
        }
      } else {
        this.typeError = true
      }
    },
    removeFile(index) {
      this.files.splice(index, this.one)
      this.filesName.splice(index, this.one)
      this.filesSize.splice(index, this.one)
      this.emitFiles(index)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/js/components/Uploader/Uploader.vue